import { createSlice } from "@reduxjs/toolkit";

const colors = [
  "#F2CA00",
  "#503bc1",
  "#E56B1F",
  "#34bd7b",
  "#0077b6",
  "#d27b78",
  "#807050",
  "#c70039",
  "#e5b808",
  "#902bf8",
];
const mode = ["dark", "light"];
const initialState = {
  colors: colors,
  mode: localStorage.getItem("mode") ? localStorage.getItem("mode") : mode[0],
  originalMode: localStorage.getItem("mode")
    ? localStorage.getItem("mode") === "auto"
      ? mode[0]
      : localStorage.getItem("mode")
    : mode[0],
  mainColor: localStorage.getItem("mainColor")
    ? localStorage.getItem("mainColor")
    : colors[0],
  autoValue: null,
  direction: localStorage.getItem("i18nextLng")?.startsWith("ar")
    ? "rtl"
    : "ltr",
  isChangingDirection:false
};

const themeSlice = createSlice({
  name: "themeValues",
  initialState,
  reducers: {
    apply(state, action) {
      state.mainColor = action.payload.mainColor;
      state.mode = action.payload.mode;
      state.originalMode =
        action.payload.mode === "auto" ? state.autoValue : action.payload.mode;
      localStorage.setItem("mode", action.payload.mode);
      localStorage.setItem("mainColor", action.payload.mainColor);
    },
    setDirection(state, action) {
      state.direction = action.payload.directionValue;
    },
    changingDirection(state, action) {
      state.isChangingDirection = action.payload.value;
    },
    setAutoValue(state, action) {
      state.autoValue = action.payload.autoValue;
      const currentMode =
        state.mode === "auto" ? action.payload.autoValue : state.mode;
      state.originalMode = currentMode;
    },
  },
});

export const { apply, setAutoValue, setDirection,changingDirection } = themeSlice.actions;
export default themeSlice.reducer;
